import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import globalStyles from "../../../assets/styles/global.module.scss";
import style from "../../../assets/styles/componentStyles/conversionLeadsStyles/conversionLeadsStyle.module.scss";
import dashboardStyles from './../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss';
import feedbackStyles from "../../../assets/styles/componentStyles/feedbackStyles/feedbackStyle.module.scss";
import { useConversionLeadStore } from '../../../store/conversionLeadStore';
import { useShallow } from 'zustand/react/shallow';
import { LeadOrder } from '../../../models/axiosModel';
import { formatDateAccordingToTimezoneUsingMoment, getValueOrDefault, thousandSeparator } from '../../../utils/constants';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import EditIcon from '@mui/icons-material/Edit';
import { greyColor } from '../../../utils/colors';
import GlobalPopUp from '../../../components/utility/globalPopUp';
import UpdateLeadStatusPopup from './updateLeadStatusPopup';

interface ConversionLeadTableProps {
    getLeadOrdersApiCall: (limit: number, offset: number, flagUpdate: boolean) => Promise<void>,
}

const ConversionLeadTable: React.FC<ConversionLeadTableProps> = (props) => {
    
    const { getLeadOrdersApiCall } = props;

    const breakPoints = {
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    }
    const tableInnerHeight = window.innerHeight - 200;

    const { userDetail } = useContext(UserContext) as UserContextPayload;
    const [page, setPage] = useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = useState<number>(100);

    const [selectedLead, setSelectedLead] = useState<LeadOrder | null>(null);
    const [flagUpdateLeadStatusPopup, setFlagUpdateLeadStatusPopup] = useState<boolean>(false);

    const { conversionLeadData, totalLeads, setConversionLeadData, setTotalLeads, setLeadOrderspageCache } = useConversionLeadStore(useShallow((state) => ({
        conversionLeadData: state.conversionLeadData,
        totalLeads: state.totalLeads,
        setConversionLeadData: state.setConversionLeadData,
        setTotalLeads: state.setTotalLeads, 
        setLeadOrderspageCache: state.setLeadOrderspageCache
    })));

    useEffect(() => {
        getLeadOrdersApiCall(rowsPerPage, page * rowsPerPage, false);

        // Cleanup function to reset the state
        return () => {
            setConversionLeadData(null);
            setTotalLeads(0);
            setLeadOrderspageCache({});
        }
    }, []);

    const handleChangePage = (_event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        setPage(newPage);
        getLeadOrdersApiCall(rowsPerPage, newPage * rowsPerPage, false);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
        getLeadOrdersApiCall(newRowsPerPage, 0, false);
    };

    const onClickOfUpdateStatusIcon = (lead: LeadOrder) => {
        setSelectedLead(lead);
        setFlagUpdateLeadStatusPopup(true);
    } 

    const onCloseOfUpdateStatusPopup = () => {
        setSelectedLead(null);
        setFlagUpdateLeadStatusPopup(false);
    }

    const getLeadOrderApiCallAfterUpdate = () => {
        getLeadOrdersApiCall(rowsPerPage, page * rowsPerPage, true);
    }

    return (
        <>
            <Grid container className={`${globalStyles.flexColumn} ${globalStyles.gapTwo}`}>
                <Grid item className={`${globalStyles.fullwidth}`}>
                    <TableContainer className={globalStyles.WritewizGlobaltable} sx={{ maxHeight: `${tableInnerHeight}px !important` }}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle}`}>Lead Name</TableCell>
                                    <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle}`}>Lead Phone Number</TableCell>
                                    <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle}`}>Lead Source</TableCell>
                                    <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle}`}>Lead Status</TableCell>
                                    <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle}`}>Meta Ad Name</TableCell>
                                    <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle}`}>Product Name</TableCell>
                                    <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle}`}>Order Amount</TableCell>
                                    <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle}`}>Updated At</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(conversionLeadData && conversionLeadData?.length > 0) ? 
                                    conversionLeadData?.map((lead: LeadOrder, ind: number) => {
                                        return (
                                            <TableRow className={`${dashboardStyles.cellRow} ${style.conversationLeadTableRow}`} key={ind}>
                                                <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle}`}>{getValueOrDefault(lead?.sales_lead_name)}</TableCell>
                                                <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle}`}>{getValueOrDefault(lead?.sales_lead_phone_number)}</TableCell>
                                                <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle}`}>{getValueOrDefault(lead?.sales_lead_source_name)}</TableCell>
                                                <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle}`}>
                                                    <Grid container gap={1} flexWrap={"nowrap"}>
                                                        <Grid item>
                                                            {getValueOrDefault(lead?.sales_lead_status_name)}
                                                        </Grid>
                                                        {lead?.sales_lead_status_name?.toLowerCase() === 'addtocart' && 
                                                            <Grid item className={style.editIconGrid} onClick={() => onClickOfUpdateStatusIcon(lead)}>
                                                                <EditIcon className={style.editIcon} />
                                                            </Grid>
                                                        }
                                                    </Grid>
                                                </TableCell>
                                                <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle}`}>{getValueOrDefault(lead?.meta_ad_name)}</TableCell>
                                                <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle}`}>{getValueOrDefault(lead?.ecom_product_name)}</TableCell>
                                                <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle}`}>{`${lead?.ecom_order_amount ? `${getValueOrDefault(thousandSeparator(lead?.ecom_order_amount))} ${getValueOrDefault(lead?.ecom_order_currency)}` : `-`}`}</TableCell>
                                                <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle}`}>{formatDateAccordingToTimezoneUsingMoment(lead?.sales_lead_timestamp, userDetail.timezone_hour)}</TableCell>
                                            </TableRow>
                                        );
                                    })
                                    :
                                    <TableRow className={dashboardStyles.cellRow}>
                                        <TableCell colSpan={12} className={globalStyles.textCenter}>
                                            No Data Available
                                        </TableCell>
                                    </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>

                {totalLeads > 0 &&
                    <Grid item className={globalStyles.textItemsEnd}>
                        <Grid container className={globalStyles.contentEnd}>
                            <Grid item className={style.conversationLeadTablePaginationGrid}>
                                <TablePagination
                                    component="div"
                                    className={`${feedbackStyles.feedbackTablePaginationStyle} ${style.conversationLeadTablePagination}`}
                                    count={totalLeads}
                                    rowsPerPageOptions={[100]}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    labelDisplayedRows={({ from, to, count, page }) => `Records: ${from}-${to} of ${count}`}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                }

                {flagUpdateLeadStatusPopup && 
                    <GlobalPopUp
                        open={flagUpdateLeadStatusPopup}
                        flagShowCloseIcon
                        handleClose={() => onCloseOfUpdateStatusPopup()}
                        onClose={() => onCloseOfUpdateStatusPopup()}
                        paperMinWidth={breakPoints.flagSmallScreen ? "310px" : "600px"}
                        paperMaxwidth={breakPoints.flagSmallScreen ? "610px" : "650px"}
                        borderRadius='10px'
                        titlePadding='0px'
                    >
                        <UpdateLeadStatusPopup
                            selectedLead={selectedLead as LeadOrder}
                            onCloseOfUpdateStatusPopup={onCloseOfUpdateStatusPopup}
                            getLeadOrderApiCallAfterUpdate={getLeadOrderApiCallAfterUpdate}
                        />
                    </GlobalPopUp>
                }
            </Grid>
        </>
    )
}

export default ConversionLeadTable
